'use client';

import { Close } from '@radix-ui/react-popover';
import { Url } from 'next/dist/shared/lib/router/router';
import Link from 'next/link';
import { FC, ReactNode } from 'react';

type Props = {
	children: ReactNode;
	href: Url;
	onClick?: () => void;
	mobile?: boolean;
};

const NavbarLink: FC<Props> = ({ href = '/', children, onClick, mobile = false }) => {
	const handleClick = () => {
		// Executar callback adicional se fornecido
		if (onClick) {
			onClick();
		}
	};

	const linkElement = (
		<Link
			href={href}
			onClick={handleClick}
			className="flex items-center text-base leading-none whitespace-nowrap font-bold md:px-6 lg:px-16 hover:bg-base-grey-2 active:bg-base-grey-3 transition-colors ease-in-out duration-200"
		>
			{children}
		</Link>
	);

	// Para mobile, envolver com Close para fechar o menu automaticamente
	if (mobile) {
		return <Close asChild>{linkElement}</Close>;
	}

	return linkElement;
};

export default NavbarLink;
